import React from 'react'
import { RowType } from 'scenes/Dashboard/components/RowCell'
import { Person } from 'scenes/Dashboard/data/people/types'

import { Hidden, TableRow } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import {
  CurrentPositionsCell,
  EmailCell,
  EmailValidationCell,
  FirstNameCell,
  LastNameCell,
  LinkedinCell,
} from './PersonRow.partials'
import styles from './PersonRow.style'

class PersonRow extends React.PureComponent<PersonRowProps & WithStyles<typeof styles>> {
  render() {
    const { classes, style, header, person, onClick } = this.props
    const rowType = header ? RowType.header : RowType.default
    const { id, firstName, lastName, email, emailValidationStatus, linkedinUrl, currentPositions } = (person ||
      {}) as any

    return (
      <TableRow key={id} style={style} className={classes.row} hover={!header}>
        <FirstNameCell rowType={rowType} firstName={firstName} onClick={onClick} />
        <LastNameCell rowType={rowType} lastName={lastName} onClick={onClick} />
        <Hidden smDown>
          <EmailCell rowType={rowType} email={email} onClick={onClick} />
        </Hidden>
        <Hidden smDown>
          <EmailValidationCell rowType={rowType} emailValidationStatus={emailValidationStatus} onClick={onClick} />
        </Hidden>
        <Hidden smDown>
          <LinkedinCell rowType={rowType} linkedinUrl={linkedinUrl} onClick={onClick} />
        </Hidden>
        <Hidden mdDown>
          <CurrentPositionsCell rowType={rowType} currentPositions={currentPositions} onClick={onClick} />
        </Hidden>
      </TableRow>
    )
  }
}

export type PersonRowProps = {
  header?: boolean
  style?: React.CSSProperties
  person?: Person
  onClick?: () => void
}

export default withStyles(styles)(PersonRow)
